module.exports = __webpack_public_path__ + "static/media/career-large.536b87dd.jpg";